import * as React from "react";
import { forwardRef } from "react";
const SvgPause = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M21.363 15v70h19.092V15zm38.182 0v70h19.092V15z" />
  </svg>
);
const ForwardRef = forwardRef(SvgPause);
export default ForwardRef;
